import React from 'react';
import { Plus } from 'lucide-react';
import { isTodayOrFuture } from '../../utils/dateHelpers';

interface CustomDateCellHeaderProps {
  date: Date;
  label: string;
  onAddClick: (date: Date) => void;
}

export function CustomDateCellHeader({ date, label, onAddClick }: CustomDateCellHeaderProps) {
  const canSchedule = isTodayOrFuture(date);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAddClick(date);
  };

  return (
    <div className="rbc-date-cell-header flex items-center justify-between px-2">
      <span className="text-sm font-semibold">{label}</span>
      {canSchedule && (
        <button
          onClick={handleClick}
          className="p-1 hover:bg-gray-200 rounded transition-colors"
          title="Schedule activity"
        >
          <Plus className="h-4 w-4 text-gray-600" />
        </button>
      )}
    </div>
  );
}
